<template>
  <div>
    <v-container fluid grid-list-md>
      <progress-bar></progress-bar>
      <v-toolbar class="mb-4">
        <v-toolbar-title>
          Profile
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="app_filter">
          <v-btn small color="success" @click="save">Save</v-btn>
        </div>
      </v-toolbar>
      <v-layout row wrap class="mt-3">
        <v-flex xs12 sm6 md4>
          <v-card>
            <v-card-text>
              <div class='sl_form_title'>
                <h3>Main info</h3>
              </div>
              <v-divider class='mt-2 mb-3'></v-divider>
              <v-text-field v-model="form.email" :error-messages="errorMessages('email')" label="Email"></v-text-field>
              <v-text-field v-model="form.firstname" :error-messages="errorMessages('firstname')" label="Firstname"></v-text-field>
              <v-text-field v-model="form.lastname" :error-messages="errorMessages('lastname')" label="Lastname"></v-text-field>
              <v-text-field v-model="form.phone" :error-messages="errorMessages('phone')" label="Phone"></v-text-field>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-card>
            <v-card-text>
              <div class='sl_form_title'>
                <h3>Password changes</h3>
              </div>
              <v-divider class='mt-2 mb-3'></v-divider>
              <v-text-field type='password' v-model="passwordForm.password" :error-messages="errorMessages('password')" label="Enter new password"></v-text-field>
              <v-text-field type='password' v-model="passwordForm.password_confirmation" :error-messages="errorMessages('password_confirmation')" label="Repeat password"></v-text-field>
              <v-btn block small color="success" @click="changePassword">Change password</v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import * as mixins from '@/mixins/'
  import * as storage from '@/utils/storage'

  export default {
    name: 'UserProfile',
    mixins: [mixins.preloader, mixins.user, mixins.errors],
    data() {
      return {
        errors: [],
        form: {
          email: "",
          firstname: "",
          lastname: "",
          phone: "",
        },
        passwordForm: {
          password: '',
          password_confirmation: ''
        }
      }
    },
    methods: {
      getUser() {
        return this.$api.profile.get().then((response) => {
          this.errors = []
          this.form = response.data
        })
      },
      save() {
        this.$api.profile.set(this.form).then(() => {
          this.$router.push('/')
        }, response => {
          this.errors = response.errors
        })
      },
      changePassword() {
        this.$api.profile.changePassword(this.passwordForm).then((response) => {
          this.errors = []
          this.passwordForm = {
            password: '',
            password_confirmation: ''
          }
          storage.token.set(response.data.api_token)
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'Password successfully changed'
          })
        }, response => {
          this.errors = response.errors
        })
      }
    },
    mounted() {
      if(this.user) {
        this.queue(this.getUser())
      }
    }
  }
</script>
